import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useLanguages } from "@/hooks/useLanguages";

interface TranslationStatusProps {
  translations: Record<string, string>;
}

export const TranslationStatus = ({ translations }: TranslationStatusProps) => {
  const { data: languages } = useLanguages();
  
  if (!languages) {
    return <div className="text-xs text-muted-foreground">Loading...</div>;
  }

  return (
    <TooltipProvider>
      <div className="flex flex-wrap gap-1">
        {languages.map((lang) => {
          const hasTranslation = translations && translations[lang.code] && translations[lang.code].trim() !== '';
          
          return (
            <Tooltip key={lang.code}>
              <TooltipTrigger asChild>
                <Badge 
                  variant={hasTranslation ? "default" : "secondary"}
                  className={`text-xs uppercase ${hasTranslation ? 'bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-200' : 'bg-muted text-muted-foreground'}`}
                >
                  {lang.code}
                </Badge>
              </TooltipTrigger>
              <TooltipContent>
                <p>{hasTranslation ? `Translation available in ${lang.name}` : `No translation in ${lang.name}`}</p>
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};